module.exports = __webpack_public_path__ + "assets/normal/images/certificateDefault.5169b73e.png";